export const jsonFormatText = (text?: string | number): string => {
  if (text) {
    if (typeof text === 'number') {
      text = text.toString()
    }
    text = text.trim().replace(/\s+/g, ' ')
    if (text.length > 0) {
      return text
    }
  }
  return null
}

export const isValidateNullText = (text?: string | number): boolean => {
  return !jsonFormatText(text)
}
